import { useEffect, useState } from 'react';

type HealthStatus = "ok" | "warning" | "error";

export function useDbHealthCheck() {
  const [status, setStatus] = useState<HealthStatus>('ok');

  const endpoint = process.env.REACT_APP_API_URL as string;

  useEffect(() => {
    const checkHealth = async () => {
      try {
        // Check API health
        const apiCheck = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ 
            query: `
              query HealthCheck {
                dbHealth: health(service: "db") {
                    status
                    message
                    service
                }
              }
            `
          }),
        });

        const json = await apiCheck.json();

        if (json.data) {
          setStatus(
            json.data.dbHealth?.status || 'error'
          );
        } else {
          setStatus(
             'error'
          );
        }
      } catch {
        setStatus(
          'error'
        );
      }
    };

    const interval = setInterval(checkHealth, 30000); // Check every 30 seconds
    checkHealth(); // Initial check

    return () => clearInterval(interval);
  }, [endpoint]);

  return status;
}